import React from 'react'

const DescriptionEditor = ({
  selectedMedia,
  isOwner,
  editingDescription,
  newDescription,
  loading,
  onStartEditDescription,
  onSaveDescription,
  onCancelEdit,
  onSetNewDescription
}) => (
  <div>
    <h4 className="text-white font-medium mb-3">Description</h4>
    {editingDescription === selectedMedia._id ? (
      <EditDescriptionForm
        newDescription={newDescription}
        loading={loading}
        onSave={() => onSaveDescription(selectedMedia._id)}
        onCancel={() => onCancelEdit('description')}
        onSetNewDescription={onSetNewDescription}
      />
    ) : (
      <DisplayDescription
        selectedMedia={selectedMedia}
        isOwner={isOwner}
        onStartEdit={() => onStartEditDescription(selectedMedia)}
      />
    )}
  </div>
)

const EditDescriptionForm = ({ newDescription, loading, onSave, onCancel, onSetNewDescription }) => (
  <div className="space-y-3">
    <textarea
      value={newDescription}
      onChange={(e) => onSetNewDescription(e.target.value)}
      placeholder="Add a description..."
      maxLength={200}
      rows={4}
      className="w-full px-3 py-2 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 resize-none"
    />
    <div className="flex gap-2">
      <button
        onClick={onSave}
        disabled={loading}
        className="bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white font-medium py-2 px-4 rounded-lg transition-colors"
      >
        {loading ? 'Saving...' : 'Save'}
      </button>
      <button
        onClick={onCancel}
        className="bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
      >
        Cancel
      </button>
    </div>
  </div>
)

const DisplayDescription = ({ selectedMedia, isOwner, onStartEdit }) => (
  <div className="space-y-3">
    <p className="text-gray-300 min-h-[60px] p-3 bg-white/5 rounded-lg">
      {selectedMedia.description || 'No description added'}
    </p>
    {isOwner && (
      <button
        onClick={onStartEdit}
        className="text-purple-400 hover:text-purple-300 font-medium transition-colors"
      >
        Edit Description
      </button>
    )}
  </div>
)

export default DescriptionEditor